import { getContentSettingsByIds } from 'helper/LearningSpaceServices/LocalStore';
import { getContentSettingsByContentListLocally } from 'helper/LearningSpaceServices/DataService';
import { user } from 'helper/currentUser';

const getPreRequisites = async (courseId) => {
  const offerContentSetting = await getContentSettingsByIds([courseId]);
  // debugger;
  if (
    offerContentSetting[0]
    && offerContentSetting[0].prerequisites
    && offerContentSetting[0].prerequisites.length > 0
  ) {
    const offerIds = offerContentSetting[0].prerequisites.map(pr => pr.offerId);
    const offersData = await getContentSettingsByContentListLocally(
      offerIds.map(offerId => ({
        contentId: offerId,
        contentType: 'offer'
      })),
      ['enrolments', 'states', 'contentSettings'],
      user.id()
    );

    return offersData;
  }
  // debugger;
  return {};
};

export default getPreRequisites;
